module.exports = __webpack_public_path__ + "static/media/square-full.936318c7.svg";